<template>
  <report-panel
    :isVisible="isVisibleReports"
    @update:isVisible="$emit('update:isVisibleReports', $event)"
    :isLazy="true"
  >
    <template v-slot:content>
      <div class="row m-2">
        <div class="col-12">
          <el-tabs :value="activeTabReports" @input="$emit('update:activeTabReports', $event)">
            <!-- TAB SPECIAL INSTRUCTIONS -->
            <el-tab-pane name="special-instructions">
              <template v-slot:label>
                <span class="el-tabs__custom-label">{{L10n('special-instructions')}}</span>
              </template>
              <tab-special-instructions :editorID="editorID" :filterID="filterID" tabName="special-instructions" @command="command"></tab-special-instructions>
            </el-tab-pane>
            <!-- TAB ISO NON CONFORMITY -->
            <el-tab-pane name="iso-non-conformity">
              <template v-slot:label>
                <span class="el-tabs__custom-label">{{L10n('iso-non-conformity')}}</span>
              </template>
              <tab-iso-non-conformity :filterID="filterID" tabName="iso-non-conformity" @command="command"></tab-iso-non-conformity>
            </el-tab-pane>
            <!-- TAB QUALITY SCORE -->
            <el-tab-pane name="quality-score">
              <template v-slot:label>
                <span class="el-tabs__custom-label">{{L10n('quality-score')}}</span>
              </template>
              <tab-quality-score :filterID="filterID" tabName="quality-score" @command="command"></tab-quality-score>
            </el-tab-pane>
            <!-- TAB STOCK PN -->
            <el-tab-pane name="stock-pn">
              <template v-slot:label>
                <span class="el-tabs__custom-label">{{L10n('stock-pn-from-same-shop')}}</span>
              </template>
              <tab-stock-pn :filterID="filterID" tabName="stock-pn" @command="command"></tab-stock-pn>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </template>
  </report-panel>
</template>

<script>
export default {
  name: 'Index',
  components: {
    'report-panel': () => import(/* webpackChunkName: 'ReportPanel' */ '@/components/UI/ReportPanel.vue'),
    'tab-special-instructions': () => import(/* webpackChunkName: 'RFQSupplierQuotesReports' */ './ReportsTabSpecialInstructions/Index.vue'),
    'tab-iso-non-conformity': () => import(/* webpackChunkName: 'RFQSupplierQuotesReports' */ './ReportsTabISONonConformity/Index.vue'),
    'tab-quality-score': () => import(/* webpackChunkName: 'RFQSupplierQuotesReports' */ './ReportsTabQualityScore/Index.vue'),
    'tab-stock-pn': () => import(/* webpackChunkName: 'RFQSupplierQuotesReports' */ './ReportsTabStockPn/Index.vue')
  },
  props: {
    isVisibleReports: { required: true },
    activeTabReports: { required: true },
    editorID: { required: true },
    filterID: { required: true }
  },
  methods: {
    command (command) {
      this.$emit('command', command)
    }
  }
}
</script>
